<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container>
    <div class="slideshow-container">
      <div style="text-align: center;">
        <div style="font-family: 'Faune'; width: 554px; margin: auto; font-size: 24px;">
          Oh non ! Votre petit groupe vient de faire une pause … mais dans une zone infestée de chenilles urticantes !
          Ça vous démange terriblement.
        </div>
        <img src="https://cdn.exploreve.fr/content/cluedo/Chenilles.svg" height="400px" />
      </div>
    </div>
  </b-container>
</template>
<style></style>
<script>
export default {
  mounted() {
    this.$emit("recupObject", "piqure");
  }
};
</script>
